/* eslint-disable camelcase */
import { useCallback } from 'react';
import { Child, useGetUserCountry } from 'react-easyrocket';

const slideCodesToHideByGeo: Record<string, string[]> = {
  ROU: ['tournaments_mega_roulette_madness', 'pragmatic_hallowins', 'tournaments_drops_wins'],
  SWE: ['welcome_bonus', 'monday_bonus'],
  FIN: ['welcome_bonus', 'monday_bonus']
};

const slidesForLimitedCountries: Record<string, string[]> = {
  dino_drop: ['FIN']
};

export const useHideSlidesByGeo = () => {
  const { userCountry } = useGetUserCountry();

  return useCallback(
    (slides: Child[]) => {
      if (!userCountry?.country) return slides;

      const slidesFilteredByCountry = slides.filter((slide) => {
        const geoToShowSlide = slidesForLimitedCountries[slide.code];
        const shouldShowSlideByGeo = geoToShowSlide?.includes(userCountry?.country);

        if (geoToShowSlide) {
          return shouldShowSlideByGeo;
        }
        return true;
      });

      const bannedSlidesList = slideCodesToHideByGeo[userCountry.country];

      if (bannedSlidesList) {
        return slidesFilteredByCountry.filter((slide) => !bannedSlidesList.includes(slide.code));
      }
      return slidesFilteredByCountry;
    },
    [userCountry?.country]
  );
};
